import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import {groupEmployeeCustomFields} from 'shared/tools';

class EmployeeCustomFieldsState {
  store = new DomainStore();

  category;
  employeeCustomFields = [];

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({employeeCustomFields, category}) {
    this.employeeCustomFields = employeeCustomFields;
    this.category = category;
  }

  async load() {
    await this.store._compose([
      endpoints.CUSTOM_FIELD_GROUPS.with(this.category)
    ]);
  }

  get sortedCustomFieldGroups() {
    return groupEmployeeCustomFields(this.employeeCustomFields, this.store._getAll(types.CUSTOM_FIELD_GROUP));
  }
}

export default EmployeeCustomFieldsState;
